/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { CBQLectureExam } from "./cbqStudentTypes";

type GetCBQByQuizResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: CBQLectureExam[];
};

// GET /cbq/exams?quizId=<id> — CBQ exams linked to an MCQ quiz (same list shape
// as the per-lecture endpoint, plus quizGate / requiredQuizScore).
export const GetCBQByQuiz = async (
  quizId: string
): Promise<GetCBQByQuizResponse> => {
  try {
    const response = await axios.get(`/cbq/exams`, { params: { quizId } });
    const raw = response.data?.data ?? response.data;
    const list: CBQLectureExam[] = Array.isArray(raw) ? raw : raw?.data ?? [];
    return { data: list };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      if (error.response.status === 404) return { data: [] };
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
